<template>
    <v-container id="cuotaanualmatriculadosv2-caplp">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card dark color="success" class="alineacentro DatosMatriculado">
            <v-card-text class="DatosMatriculado"
              ><strong>CUOTAS ANUALES</strong></v-card-text
            >
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-spacer />
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="3">
          <v-select
            v-model="filtroanio"
            :items="listaanios"
            label="Año"
            item-text="anio"
            item-value="idanio"
            v-on:change="ActualizaGrilla"
          />
        </v-col>
        <v-col cols="9" class="alineaizquierda">
          <v-btn
            class="ma-2"
            dark
            x-small
            color="primary"
            title="Listar"
            @click="ActualizaGrilla"
            :disabled="!permisolectura"
          >
            <v-icon dark> mdi-magnify </v-icon>
          </v-btn>
          <v-btn
            class="ma-2"
            dark
            x-small
            color="primary"
            title="Nueva Cuota Anual"
            @click="NuevaCuota"
            :disabled="!permisoescritura"
          >
            <v-icon dark> mdi-new-box </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col cols="12">
          <v-data-table
            v-model="cuotaseleccionada"
            :headers="columnascuotas"
            :items="listacuotas"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Filas por Página:',
              'items-per-page-all-text': 'Todos',
            }"
            item-key="idtramite"
            class="elevation-1"
            dense
            no-data-text="Sin Registros"
            multi-sort
          >
            <!-- <template v-slot:item.actions="{ item }">
            </template> -->
          </v-data-table>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialogmensaje = false; if(mensajehome===true){$router.push('Home')}">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialognuevacuota" persistent max-width="1200">
        <v-card>
          <v-card-title class="headline">
            Nueva Cuota Anual
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="green darken-1" text @click="GrabarNuevaCuota">
                  Grabar
                </v-btn>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialognuevacuota = false"
                >
                  Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-text>
            <v-container>
              <v-row row wrap>
                <v-col cols="12" sm="6" md="6">
                  <v-row row wrap>
                    <v-col cols="12" sm="3" md="3">
                      <v-text-field
                        v-model="editedcuota.anio"
                        :rules="[rules.requerido,rules.anio]"
                        label="Año"
                        type="number"
                      />
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                      <v-menu
                        ref="menufdev"
                        v-model="menufdev"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechalocalfechadevengado"
                            label="Fecha Devengado"
                            prepend-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                            :rules="[rules.requerido]"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="editedcuota.fechadevengado"
                          @input="menufdev = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="alineaderecha">
                      <p class="TextoUHON">Valor actual del UHON: $ {{ valorUHON }}</p>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      Matriculados Normales (Más de 5 años de antigüedad en el título.)
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        label="Der. Inscripción (UHON)"
                        v-model="editedcuota.cuoderinsmayores"
                        type="number"
                        :rules="[rules.requerido]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        label="Cuota Anual PU (UHON)"
                        v-model="editedcuota.cuoanualmayoresPU"
                        type="number"
                        :rules="[rules.requerido]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        label="Cuota Anual (UHON)"
                        v-model="editedcuota.cuoanualmayores"
                        type="number"
                        :rules="[rules.requerido]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      Jóvenes Profesionales (Hasta 5 años de antigüedad en el título.)
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        label="Der. Inscripción (UHON)"
                        v-model="editedcuota.cuoderinsjovenes"
                        type="number"
                        :rules="[rules.requerido]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        label="Cuota Anual PU (UHON)"
                        v-model="editedcuota.cuoanualjovenesPU"
                        type="number"
                        :rules="[rules.requerido]"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        label="Cuota Anual (UHON)"
                        v-model="editedcuota.cuoanualjovenes"
                        type="number"
                        :rules="[rules.requerido]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="1"><v-spacer /></v-col>
                <v-col cols="12" sm="5" md="5">
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-select
                        v-model="editedcuota.cantcuotas"
                        :items="listacantidadcuotas"
                        label="Cuotas"
                        v-on:change="selcantidadcuotas"
                      />
                    </v-col>
                  </v-row>
                  <v-row row wrap>
                    <v-col cols="12">
                      <v-data-table
                        :headers="columnasccuotas"
                        :items="editedcuota.listafechascuotas"
                        class="elevation-1"
                        hide-default-footer
                      >
                        <template v-slot:item.vencimiento="props">
                          <v-menu
                            :v-model="'menufvence.menufvence' + props.item.nrocuota"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="props.item.vencimiento"
                                label="Vencimiento"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                type="date"
                                :rules="[rules.requerido]"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="props.item.vencimiento"
                              @input="CerrarCalendar(props.item.nrocuota)"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  <script>
  import axios from "@/axios";
  export default {
    name: "CuotaAnualV2",
    data() {
      return {
        loading: false,
        usuario: '',
        permisolectura: false,
        permisoescritura: false,
        nromodulo: 60,
        dialogmensaje: false,
        mensajetitulo: "",
        mensajecuerpo: "",
        mensajehome: false,
        listaanios: [], //[{idanio:-1, anio: '(TODOS)'},{idanio:2020, anio: '2020'},{idanio:2021, anio: '2021'},{idanio:2022, anio: '2022'}],
        filtroanio: -1,
        cuotaseleccionada: [],
        columnascuotas: [
          {
            text: "Año",
            align: "center",
            sortable: true,
            value: "anio",
            width: 75,
          },
          {
            text: "May.Insc.",
            align: "center",
            sortable: true,
            value: "cuoderinsmayores",
            width: 110,
          },
          {
            text: "May.Anual",
            align: "center",
            sortable: true,
            value: "cuoanualmayores",
            width: 110,
          },
          {
            text: "May.Anual PU",
            align: "center",
            sortable: true,
            value: "cuoanualmayoresPU",
            width: 125,
          },
          {
            text: "Jov.Insc.",
            align: "center",
            sortable: true,
            value: "cuoderinsjovenes",
            width: 110,
          },
          {
            text: "Jov.Anual",
            align: "center",
            sortable: true,
            value: "cuoanualjovenes",
            width: 110,
          },
          {
            text: "Jov.Anual PU",
            align: "center",
            sortable: true,
            value: "cuoanualjovenesPU",
            width: 125,
          },
          {
            text: "Asiento",
            align: "center",
            sortable: true,
            value: "asiento",
            width: 95,
          },
          {
            text: "Mayores",
            align: "center",
            sortable: true,
            value: "cantmayores",
            width: 100,
          },
          {
            text: "Jóvenes",
            align: "center",
            sortable: true,
            value: "cantjovenes",
            width: 100,
          },
          {
            text: "Total",
            align: "center",
            sortable: true,
            value: "totalgeneral",
            width: 140,
          },
          {
            text: "Cuotas",
            align: "center",
            sortable: true,
            value: "cantidadcuotas",
            width: 95,
          }
        ],
        listacuotas: [],
        dialognuevacuota: false,
        editedcuota: {
          anio: new Date().getFullYear(),
          fechadevengado: '',
          cuoderinsmayores: 0,
          cuoanualmayores: 0,
          cuoanualmayoresPU: 0,
          cuoderinsjovenes: 0,
          cuoanualjovenes: 0,
          cuoanualjovenesPU: 0,
          cantcuotas: '',
          listafechascuotas: [],
          usuario: ''
        },
        listacantidadcuotas: [1,2,3,4,5,6,7,8,9,10,11,12],
        menufvence:{
          menufvence1: false,
          menufvence2: false,
          menufvence3: false,
          menufvence4: false,
          menufvence5: false,
          menufvence6: false,
          menufvence7: false,
          menufvence8: false,
          menufvence9: false,
          menufvence10: false,
          menufvence11: false,
          menufvence12: false
        },
        menufdev: false,
        columnasccuotas: [
          {
            text: "Nro",
            align: "center",
            sortable: true,
            value: "nrocuota",
            width: 100,
          },
          {
            text: "Vencim.",
            align: "center",
            sortable: true,
            value: "vencimiento",
            width: 100,
          }
        ],
        rules: {
          requerido: (value=> value!=null && value !='') || 'Requerido',
          anio: value => value - Math.floor(value) == 0 && value>=2022 || 'Valor de año no válido',
        },
        valorUHON: 0
      }
    },
    mounted() {
      this.loading=true;
      this.usuario= localStorage.getItem('user')
      var permisos= JSON.parse(localStorage.getItem('permisos'));
      //var idrol= localStorage.getItem('rolusuario')
      var roles= localStorage.getItem('rolesusuario')
      var existeper=permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario)  && p.idaccion===1);
      if(existeper.length===0)
      {
        this.loading=false;
        this.MostrarMensaje('Error','No tiene permisos para acceder a este módulo.',true);
      }else{
        this.permisolectura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && p.idaccion===9).length>0 ? true : false;
        this.permisoescritura= permisos.filter(p=> p.nromodulo===this.nromodulo && (roles.includes(p.idrol) || p.usuario===this.usuario) && (p.idaccion>1 && p.idaccion<9)).length>0 ? true : false;
        var i=0;
        var anioactual= (new Date()).getFullYear();
        this.listaanios.push({idanio:-1, anio: '(TODOS)'});
        for(i=2021;i<=anioactual;i++) {
          this.listaanios.push({idanio: i, anio: i.toString()});
        }
        this.ActualizaGrilla();
      }
    },
    methods: {
      ActualizaGrilla() {
        this.loading = true;
        var anio= this.filtroanio==-1 ? '0' : this.filtroanio
        axios.get("cuotaanual/" + anio).then((result) => {
          this.listacuotas = result.data;
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error,false);
        });
      },
      MostrarMensaje(titulo, cuerpo, home) {
        this.mensajetitulo = titulo;
        this.mensajecuerpo = cuerpo;
        this.mensajehome= home!=null ? home : false;
        this.dialogmensaje = true;
      },
      NuevaCuota () {
        this.loading=true;
        axios.post("tesoreria/PostUltimoValorreferenciavalor", { headers: { "Content-Type": "application/json" }}).then((result) => {
          if(result.data.resultado===0){
            //this.lista = result.data.datos;
            this.valorUHON= result.data.datos;
            this.editedcuota= {
              anio: new Date().getFullYear(),
              fechadevengado: '',
              cuoderinsmayores: 0,
              cuoanualmayores: 0,
              cuoanualmayoresPU: 0,
              cuoderinsjovenes: 0,
              cuoanualjovenes: 0,
              cuoanualjovenesPU: 0,
              cantcuotas: '',
              listafechascuotas: [],
              usuario: this.usuario
            }
            this.dialognuevacuota=true
            this.loading = false;
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      },
      GrabarNuevaCuota () {
        this.loading=true
        var valido= this.ValidarCuotaAnual()
        if(valido==='')
        {
          this.editedcuota.cuoderinsmayores=parseFloat(this.editedcuota.cuoderinsmayores)
          this.editedcuota.cuoanualmayores=parseFloat(this.editedcuota.cuoanualmayores)
          this.editedcuota.cuoanualmayoresPU=parseFloat(this.editedcuota.cuoanualmayoresPU)
          this.editedcuota.cuoderinsjovenes=parseFloat(this.editedcuota.cuoderinsjovenes)
          this.editedcuota.cuoanualjovenes=parseFloat(this.editedcuota.cuoanualjovenes)
          this.editedcuota.cuoanualjovenesPU=parseFloat(this.editedcuota.cuoanualjovenesPU)
          const cuota = JSON.stringify(this.editedcuota);
          axios.post("cuotaanual/PostCuotaAnualV2", cuota, { headers: { "Content-Type": "application/json"}}).then((result) => {
            if (result.data == "OK") {
              this.dialognuevacuota = false
              this.ActualizaGrilla()
            } else {
              this.loading = false
              this.MostrarMensaje("Error", result.data,false)
            }
          }).catch((error) => {
            this.loading = false
            this.MostrarMensaje("Error", error,false)
          });
        }else{
          this.loading= false
          this.MostrarMensaje('Error',valido,false)
        }
      },
      ValidarCuotaAnual () {
        var valido=''
        if(this.editedcuota.anio===null || this.editedcuota.anio==='')
        {
          valido='No ingreso el Año de la Cuota anual a devengar, verifique y reintente.'
        }
        if(this.editedcuota.fechadevengado===null || this.editedcuota.fechadevengado==='')
        {
          valido='No ingreso la fecha de devengamiento de la Cuota Anual, verifique y reintente.'
        }
        if(this.editedcuota.cuoderinsmayores===null || this.editedcuota.cuoderinsmayores<=0)
        {
          valido='No ingreso el valor del Derecho de Inscripcion de Matriculas Mayores, verifique y reintente.'
        }
        if(this.editedcuota.cuoanualmayores===null || this.editedcuota.cuoanualmayores<=0)
        {
          valido='No ingreso el valor de la Cuota Anual de los Matriculados mayores, verifique y reintente.'
        }
        if(this.editedcuota.cuoanualmayoresPU===null || this.editedcuota.cuoanualmayoresPU<=0)
        {
          valido='No ingreso el valor de la Cuota Anual Pago Único de los Matriculados mayores, verifique y reintente.'
        }
        if(this.editedcuota.cuoderinsjovenes===null || this.editedcuota.cuoderinsjovenes<=0)
        {
          valido='No ingreso el valor del Derecho de Inscripcion de Jovenes Profesionales, verifique y reintente.'
        }
        if(this.editedcuota.cuoanualjovenes===null || this.editedcuota.cuoanualjovenes<=0)
        {
          valido='No ingreso el valor de la Cuota Anual de Jovenes Profesionales, verifique y reintente.'
        }
        if(this.editedcuota.cuoanualjovenesPU===null || this.editedcuota.cuoanualjovenesPU<=0)
        {
          valido='No ingreso el valor de la Cuota Anual Pago Único de Jovenes Profesionales, verifique y reintente.'
        }
        if(this.editedcuota.cantcuotas===null || this.editedcuota.cantcuotas==='' || this.editedcuota.cantcuotas<=0)
        {
          valido='Debe seleccionar un valor de cuota válido (valor del 1 al 12), verifique y reintente.'
        }
        if(valido==='')
        {
          var f=0
          var fec=new Date(this.editedcuota.listafechascuotas[0].vencimiento)
          for(f=0;f<this.editedcuota.cantcuotas;f++){
            var aniocuota=new Date(this.editedcuota.listafechascuotas[f].vencimiento).getFullYear()
            var fechacuota=new Date(this.editedcuota.listafechascuotas[f].vencimiento)
            if(f===0)
            {
              fec=fechacuota
              if(fec!=null && fec!='')
              {
                if(fec.getFullYear()!=this.editedcuota.anio)
                {
                  valido='Los vencimientos de cuotas deben corresponder al mismo año de cuota anual, verifique y reintente.'
                  break
                }
              }else{
                valido='El vencimiento de alguna de las cuotas no es válido, verifique y reintente.'
                break
              }
            }else{
              if(this.editedcuota.listafechascuotas[f].vencimiento!=null && this.editedcuota.listafechascuotas[f].vencimiento!=''){
                if(aniocuota!=this.editedcuota.anio)
                {
                  valido='Los vencimientos de cuotas deben corresponder al mismo año de cuota anual, verifique y reintente.'
                  break
                }else{
                  // if(fechacuota<=fec){
                  //   valido='Los vencimientos de cada cuota deben ser mayores al de la cuota anterior, verifique y reintente.'
                  //   break
                  // }else{
                  //   fec=fechacuota
                  // }
                  fec=fechacuota
                }
              }else{
                valido='El vencimiento de alguna de las cuotas no es válido, verifique y reintente.'
                break
              }
            }
          }
        }
        return valido
      },
      selcantidadcuotas () {
        if(this.editedcuota.listafechascuotas.length<this.editedcuota.cantcuotas)
        {
          var i=this.editedcuota.listafechascuotas.length==0 ? 1 : this.editedcuota.listafechascuotas.length+1
          var dif= this.editedcuota.cantcuotas
          for(i=this.editedcuota.listafechascuotas.length==0 ? 1 : this.editedcuota.listafechascuotas.length+1;i<=dif;i++){
            this.editedcuota.listafechascuotas.push({nrocuota: i, vencimiento:''})
          }
        }else if(this.editedcuota.listafechascuotas.length>this.editedcuota.cantcuotas)
        {
          this.editedcuota.listafechascuotas=this.editedcuota.listafechascuotas.slice(0,this.editedcuota.cantcuotas)
        }
      },
      CerrarCalendar (nrocuota){
        this.$set(this.menufvence,'menufvence' + nrocuota.toString(),false)
      }
    },
    computed: {
      fechalocalfechadevengado: function () {
          if(this.editedcuota.fechadevengado!=null && this.editedcuota.fechadevengado!='')
          {
            var fecha=new Date(this.editedcuota.fechadevengado)
            fecha.setDate(fecha.getDate()+1)
            return fecha.toLocaleDateString('es-AR')
          }else{
            return ''
          }
      }
    }
  }
  </script>
  <style>
  .textocentrado {
    text-align: center;
  }
  .elementocentrado {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .col-xl,
  .col-xl-auto,
  .col-xl-12,
  .col-xl-11,
  .col-xl-10,
  .col-xl-9,
  .col-xl-8,
  .col-xl-7,
  .col-xl-6,
  .col-xl-5,
  .col-xl-4,
  .col-xl-3,
  .col-xl-2,
  .col-xl-1,
  .col-lg,
  .col-lg-auto,
  .col-lg-12,
  .col-lg-11,
  .col-lg-10,
  .col-lg-9,
  .col-lg-8,
  .col-lg-7,
  .col-lg-6,
  .col-lg-5,
  .col-lg-4,
  .col-lg-3,
  .col-lg-2,
  .col-lg-1,
  .col-md,
  .col-md-auto,
  .col-md-12,
  .col-md-11,
  .col-md-10,
  .col-md-9,
  .col-md-8,
  .col-md-7,
  .col-md-6,
  .col-md-5,
  .col-md-4,
  .col-md-3,
  .col-md-2,
  .col-md-1,
  .col-sm,
  .col-sm-auto,
  .col-sm-12,
  .col-sm-11,
  .col-sm-10,
  .col-sm-9,
  .col-sm-8,
  .col-sm-7,
  .col-sm-6,
  .col-sm-5,
  .col-sm-4,
  .col-sm-3,
  .col-sm-2,
  .col-sm-1,
  .col,
  .col-auto,
  .col-12,
  .col-11,
  .col-10,
  .col-9,
  .col-8,
  .col-7,
  .col-6,
  .col-5,
  .col-4,
  .col-3,
  .col-2,
  .col-1 {
    padding: 2px !important;
  }
  @media only screen and (min-width: 960px) {
    .altojusto {
      height: 45px !important;
    }
  }
  .alineaizquierda {
    text-align: left;
  }
  .alineacentro {
    text-align: center;
  }
  .alineaderecha {
    text-align: right;
  }
  .ocupa30 {
    width: 30%;
  }
  .ocupa50 {
    width: 50%;
  }
  .ocupa75 {
    width: 75%;
  }
  .ocupa95 {
    width: 95%;
  }
  .centradovertical {
    vertical-align: middle;
    align-items: center;
  }
  .abajovertical {
    vertical-align: bottom;
  }
  .TituloGrilla {
    font-family: Tahoma;
    font-size: medium;
    font-weight: bold;
    background-color: darkgray;
  }
  .textoNegritaRojo {
    color:red !important;
    font-weight:bold !important;
  }
  .textoNegritaVerde{
    color:rgb(83, 248, 125) !important;
    font-weight:bold !important;
  }
  .TextoUHON {
    font-family: Tahoma;
    font-size: medium;
    font-weight: bold;
    background-color: rgb(80, 68, 188);
    color: white;
  }
  </style>